import apiClient from "../../../service/apiClient";
import { AUTH_ENDPOINTS } from "../../../app/apiEndpoints";
import { ADMIN_CONTACT_ENDPOINTS } from "../../../app/apiEndpoints";

export const login = (data) => {
  return apiClient.post(AUTH_ENDPOINTS.LOGIN, data);
};

export const verifyMfa = (data) => {
  return apiClient.post(AUTH_ENDPOINTS.MFA_VERIFY, data);
};

export const getMfaSetup = (data) => {
  return apiClient.post(AUTH_ENDPOINTS.MFA_SETUP,data);
};

export const getDisclaimer = (params) => {
  return apiClient.get(AUTH_ENDPOINTS.GET_DISCLAIMER, { params });
};

export const acceptDisclaimer = (data) => {
  return apiClient.post(AUTH_ENDPOINTS.ACCEPT_DISCLAIMER, data);
};

export const forgotPassword = (email) => {
  return apiClient.post(AUTH_ENDPOINTS.FORGOT_PASSWORD, { Email: email });
};

export const resolveForgotPasswordLink = (param, param1) => {
  return apiClient.get(AUTH_ENDPOINTS.RESOLVE_FORGOT_PASSWORD_LINK, { params: { param, param1 } });
};

export const getWebAdminUsersByEmail = (emailAddress, statusId = 0) => {
  return apiClient.get(ADMIN_CONTACT_ENDPOINTS.GET_CONTACTS, {
    params: { emailAddress, statusId },
  });
};

export const updateResetPassword = (data) => {
  return apiClient.post(AUTH_ENDPOINTS.UPDATE_RESET_PASSWORD, data);
};

export const getSecurityQuestions = (userid) => {
  return apiClient.get(AUTH_ENDPOINTS.GET_CHALLENGE_PHRASES,{params:{userId:userid}});
};

export const validateSecurityAnswer = (userId, qId, answer) =>{
  return apiClient.get(AUTH_ENDPOINTS.VALIDATE_SECURITY_ANSWER,{
    params:{
      userId:userId,
      qid:qId,
      sAnswer:answer
  }})
}